export default __webpack_public_path__ + "img/right-arrow-cell.4bf0ef15.svg";